export const pickStringWithLocale = (
  locale: string,
  attrName: string,
  object: any
) => {
  if (locale === 'en') {
    return object[`${attrName}En`];
  }

  if (locale === 'es') {
    return object[`${attrName}Es`];
  }

  return object[`${attrName}Es`];
};
